/**
 * Keeps a floating control off the content it would otherwise cover.
 *
 * Two pairs today:
 *   · the WhatsApp bubble (bottom-right) steps aside for the buy box
 *   · the fitting-room pill (bottom-left) steps aside for the policy rows
 *
 * The second was added with blocks/ft-policy-info (23 Oct 2026): the pill sat
 * squarely on "Read the full refund policy" and on the PAYMENT & CASH ON
 * DELIVERY heading, so the rows a shopper opens to check COD were partly
 * under a button.
 *
 * The original note, which is the reasoning for both:
 *
 * The bubble is fixed to the bottom-right corner. On a phone the buy box is
 * full-width, so as soon as the shopper scrolls Add to cart down toward the
 * bottom of the screen the bubble lands on top of it — the button is still
 * clickable everywhere else, but the one place a thumb naturally reaches is
 * covered by a green circle.
 *
 * CSS alone cannot express "is this element on screen", so: while the buy
 * buttons are anywhere in the viewport on a narrow screen, the bubble steps
 * aside. The shopper is reading the buy box at that moment and does not need
 * it; it comes straight back when they scroll on.
 *
 * Desktop is untouched — the buy box is in a side column there and the corner
 * is free.
 */
(function () {
  'use strict';

  var MOBILE = '(max-width: 749px)';

  var PAIRS = [
    // The bubble now sits ABOVE the sticky buy bar on a product page, in a
    // band roughly 70-90% down the viewport. Watching the whole viewport made
    // it disappear for most of the page - and since the buy box's own
    // "Order on WhatsApp" button was removed (it bypassed Shopify orders),
    // there was then no way to reach WhatsApp at all while scrolling the buy
    // area. So it steps aside only while the buy buttons are actually in its
    // band, which is the overlap it was written to avoid.
    { float: '.ft-wa-float', target: '.buy-buttons-block',
      margin: '-70% 0px -8% 0px' },
    { float: '.ft-fr-pill', target: '.ft-policy-info' }
  ];

  function pair(floatSelector, targetSelector, rootMargin) {
    var float = document.querySelector(floatSelector);
    if (!float || float.dataset.ftDodge) return;

    var buyBox = document.querySelector(targetSelector);
    if (!buyBox) return;

    float.dataset.ftDodge = '1';

    var mq = window.matchMedia(MOBILE);
    var observer = null;

    function set(hidden) {
      float.toggleAttribute('data-ft-dodged', hidden);
    }

    function start() {
      if (observer) return;
      observer = new IntersectionObserver(
        function (entries) {
          var entry = entries[entries.length - 1];
          if (entry) set(entry.isIntersecting);
        },
        // Default: a little slack at the bottom so the float is already gone
        // by the time the target reaches the corner, rather than vanishing
        // under it. A pair can narrow the root to its own band instead.
        { rootMargin: rootMargin || '0px 0px 40px 0px' }
      );
      observer.observe(buyBox);
    }

    function stop() {
      if (!observer) return;
      observer.disconnect();
      observer = null;
      set(false);
    }

    function sync() {
      if (mq.matches) start();
      else stop();
    }

    sync();
    // addEventListener on a MediaQueryList is not in older Safari; addListener is.
    if (mq.addEventListener) mq.addEventListener('change', sync);
    else if (mq.addListener) mq.addListener(sync);
  }

  function init() {
    for (var i = 0; i < PAIRS.length; i++) {
      pair(PAIRS[i].float, PAIRS[i].target, PAIRS[i].margin);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
